import React from 'react'
import { Canvas } from 'fabric'
import { Button, Empty } from '@pankod/refine-antd'
import { QrCode, FileType2, Signature } from 'lucide-react'

import { addText } from '../../utils/text'
import { CertificateTemplateVariables } from '@resources/lms-management/certificate-template/types'
import { QR_CODE_CERTIFICATE_KEY, TTE_PLACEHOLDER_KEY } from '../../constants'
import { addQRCode, addSignature } from '../../utils/image'

type ActorComponents = {
  canvas: Canvas | null
  variable: CertificateTemplateVariables['systemVariable']
}

const ActorComponents = (props: ActorComponents) => {
  const handleAddComponent = (value: string) => {
    if (value === QR_CODE_CERTIFICATE_KEY) {
      addQRCode(props.canvas)
      return
    }
    if (value === TTE_PLACEHOLDER_KEY) {
      addSignature(props.canvas)
      return
    }
    addText({
      canvas: props.canvas,
      value: `{{ ${value} }}`,
      customVariableKey: value,
    })
  }

  const getIconByVariable = (variable: string) => {
    if (variable === QR_CODE_CERTIFICATE_KEY) {
      return <QrCode className="h-5 w-5" />
    }
    if (variable === TTE_PLACEHOLDER_KEY) {
      return <Signature className="h-5 w-5" />
    }
    return <FileType2 className="h-5 w-5" />
  }

  return (
    <>
      <div className="grid gap-2 grid-flow-row h-full overflow-auto">
        {!props.variable.length && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Tidak ada komponen"
          />
        )}
        {props.variable.toSorted().map((key, i) => (
          <Button
            key={key + i}
            onClick={() => {
              handleAddComponent(key)
            }}
            icon={getIconByVariable(key)}
            className="!flex gap-2 items-center justify-center font-mono"
            block
            title={key}
          >
            <div className="max-w-[150px] overflow-hidden text-ellipsis">
              {key}
            </div>
          </Button>
        ))}
      </div>
    </>
  )
}

export default ActorComponents
